const QuoteApprovalReassignmentFormData = {
  CoveringManager: {
    value: "",
    type: "string",
    required: true
  },
  LeaveStartDate: {
    value: "",
    type: "string",
    required: true
  },
  LeaveEndDate: {
    value: "",
    type: "string",
    required: true
  }
};

const QuoteApprovalReassignmentFormErrorData = {
  CoveringManager: null,
  LeaveStartDate: null,
  LeaveEndDate: null
};

const setQuoteApprovalReassignmentFormFieldContent = (
formData,
onFieldValueChange,
onDateValueChange,
formError,
t
) => {
try {
  return [
  [
    {
      fieldtype: "textfield",
      id: "CoveringManager",
      type: "text",
      isMandatory: formData.CoveringManager.required,
      label: t("quoteApprovalReassignmentList.coveringManager"),
      placeholder: t("quoteApprovalReassignmentList.coveringManager"),
      onChange: onFieldValueChange,
      value: formData.CoveringManager.value,
      error: formError.CoveringManager,
      byPassRoleCheck : true
    },
    {
      fieldtype: "date",
      id: "LeaveStartDate",
      type: "text",
      isMandatory: formData.LeaveStartDate.required,
      label: t("quoteApprovalReassignmentList.leaveStartDate"),
      onChange: onDateValueChange(("LeaveStartDate")),
      value: formData.LeaveStartDate.value,
      error: formError.LeaveStartDate,
    },
    {
      fieldtype: "date",
      id: "LeaveEndDate",
      type: "text",
      isMandatory: formData.LeaveEndDate.required,
      label: t("quoteApprovalReassignmentList.leaveEndDate"),
      onChange: onDateValueChange("LeaveEndDate"),
      value: formData.LeaveEndDate.value,
      error: formError.LeaveEndDate,
    }
  ],
];
} catch (err) {
alert(err);
}
};

export { QuoteApprovalReassignmentFormData, QuoteApprovalReassignmentFormErrorData,setQuoteApprovalReassignmentFormFieldContent };
